<ng-template #noMobileStyle>
  <div class="alert-container">
    <div class="alert-container__image-container">
      <img [src]="iconImage" class='popover-image'/>
    </div>
    <div class="alert-container__detail" [ngSwitch]="myTitle">
      <ng-container *ngSwitchCase="'RESULT-FLEXIBLE-FILTER'">
        <span i18n="@@flexiblerate__alert">
          ¡Comprá tranquilo!<br />Reservá alojamientos que puedas cancelar.
        </span>
      </ng-container>
      <ng-container *ngSwitchCase="'RESULT-FILTERS-PREPAID'">
        <span i18n="@@payment__pesos">
          Pagás ahora en pesos.
        </span>
      </ng-container>
      <ng-container *ngSwitchCase="'RESULT-FILTERS-PAY_AT_DESTINATION'">
        <span i18n="@@credit_card__required">
          Necesitás una tarjeta de crédito para garantizar la reserva.
        </span>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="mobileStyle; else noMobileStyle">
  <ng-container *ngIf="openAlert;">
    <div class="mobile-container">
      <div class="mobile-container__content">
        <div>
          <img [src]="iconImage" />
        </div> 
        <div class="--detail-content" [ngSwitch]="myTitle">
          <!-- Mobile alerts here -->
        </div>
      </div>
      <div class="mobile-container__close" (click)="hide()"></div>
    </div>
  </ng-container>
</ng-container>
